import { decodeSafeEntities } from '@/lib/sanitise-strings'

export const getTopics = async () => {
  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/wp-json/wp/v2/all-topics?per_page=100&_fields[]=id&_fields[]=name&_fields[]=slug`
  const response = (await fetch(url)) as Response

  if (!response.ok) {
    return null
  }

  const data = await response.json()

  const choices = data.map((topic: { id: number; name: string; slug: string }) => ({
    value: topic.id,
    label: decodeSafeEntities(topic.name),
  }))

  return choices
}
